export enum ActionTypes {
  SET_ISLOGGEDIN = "SET_ISLOGGEDIN",
}
